import apiClient from './api'
import type { ApiResponse } from '@/types'

// INSEE SIRENE company lookup (2.4.3-003). Backed by a server proxy endpoint so
// the API key stays server-side. Returns matching companies for a name/SIRET.
export interface SireneCompany {
  siret: string
  name: string
  address: string | null
  postal_code: string | null
  city: string | null
}

export const sireneApi = {
  search: (q: string) =>
    apiClient
      .get<ApiResponse<SireneCompany[]>>('/clients/sirene/search', {
        params: { q },
      })
      .then(r => r.data),
}

export default sireneApi
